import { getMaxWidth } from 'src/services/links/measureTextWidth';
import { IGridElement, ISheetHeaders, ParameterData } from '../../types';
import { getEditorForType } from './getEditorForType';

const TARGET_URL_WIDTH = 20;
const HEADER_MIN_WIDTH = 10;
const HEADER_WIDTH_COMPENSATION = 2;

export const prepareHeaders = (parameterData: ParameterData): ISheetHeaders =>
  parameterData.map((parameter) => {
    const editorType = getEditorForType(parameter.type);
    const items =
      parameter.items &&
      parameter.items.map(({ id, name }) => ({
        label: name,
        value: { id, name },
      }));
    const itemNames = items ? items.map((i) => i.label) : [];
    const headerWidth = getMaxWidth([parameter.name, ...itemNames]);
    return {
      id: parameter.id,
      label: parameter.name,
      width: parameter.isTargetUrl
        ? TARGET_URL_WIDTH + HEADER_WIDTH_COMPENSATION
        : Math.max(headerWidth + HEADER_WIDTH_COMPENSATION, HEADER_MIN_WIDTH),
      options: items,
      targetUrl: parameter.isTargetUrl,
      type: editorType,
      validation: parameter.validation,
      validationMessage: parameter.errorMessage,
      mandatory: parameter.mandatory,
    };
  });

export const resizeHeader = (
  index: number,
  headers: ISheetHeaders,
  grid: IGridElement[][]
) => {
  return headers.map((h, i) => {
    if (i !== index) {
      return h;
    }
    const values = grid.flatMap((row) => {
      const value = row[index].value;
      return value === null ? [] : [value];
    });
    const headerWidth = getMaxWidth([h.label, ...values]);
    return {
      ...h,
      width: Math.max(
        headerWidth + HEADER_WIDTH_COMPENSATION,
        h.targetUrl
          ? TARGET_URL_WIDTH + HEADER_WIDTH_COMPENSATION
          : HEADER_MIN_WIDTH
      ),
    };
  });
};

export const getTableWidth = (headers: ISheetHeaders) => {
  return (
    headers.map((h) => h.width).reduce((a, b) => a + b, 0) +
    HEADER_WIDTH_COMPENSATION
  );
};



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulk/components/services/headers.ts